import './PlayerAction.styles.css';

import { FC, useEffect, useMemo, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';

import commonStore from '../../store/CommonStore';
import playerActionStore from '../../store/PlayerActionStore';
import { formatNumber } from '../Game/table.render.utils';
import { PlayerActionProps } from './PlayerAction.types';

const PlayerAction: FC<PlayerActionProps> = ({ pid, tableId, tableBB }) => {
  const nodeRef = useRef(null);

  const [showAction, setShowAction] = useState(false);

  const playerAction = useMemo(
    () => playerActionStore.getPlayerAction(tableId, pid),
    [pid, tableId, playerActionStore.playerActionStateChanged],
  );

  useEffect(() => {
    setShowAction(!!playerAction);
  }, [playerAction]);

  const clearAction = (): void => {
    setTimeout(() => playerActionStore.clear(tableId, pid), 1000);
  };

  return (
    <CSSTransition
      in={showAction}
      nodeRef={nodeRef}
      addEndListener={() => setShowAction(false)}
      classNames="transitionable-action-box"
      onExit={clearAction}
    >
      <div className="action-box" ref={nodeRef}>
        <p className="my-0 me-1">{playerAction?.action}</p>
        {playerAction?.bet > 0 && (
          <p className="my-0">
            {formatNumber(commonStore.convertMoney(playerAction.bet, tableBB))}
            {commonStore.getIsChipsConvertedToBlinds() && (
              <span className="bb-text">{' BB'}</span>
            )}
          </p>
        )}
      </div>
    </CSSTransition>
  );
};

export default PlayerAction;
